export const badgesModal = 'manage-badges';
export const successMessageNotification = 'success-message';
